import { SignedIn, SignedOut } from '@clerk/clerk-react';
import type { ComponentProps, ReactNode } from 'react';
import { ProtectedSignInRedirect } from './protected-sign-in-redirect';

export function isClerkEnabled(): boolean {
  return Boolean(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);
}

export function AuthGate({
  children,
  redirectUrl,
}: {
  children: ReactNode;
  redirectUrl: string;
}) {
  if (!isClerkEnabled()) {
    return <>{children}</>;
  }

  const signedInChildren = children as unknown as ComponentProps<typeof SignedIn>['children'];

  return (
    <>
      <SignedOut>
        <ProtectedSignInRedirect returnUrl={redirectUrl} />
      </SignedOut>
      <SignedIn>{signedInChildren}</SignedIn>
    </>
  );
}
